import { useWebSocketApi } from '@e3dc-react/shell/Hooks'
import { SocketStateModel } from '@e3dc-react/shell/Hooks/use-websocket-api'
import { isUndefined } from 'lodash'
import useUserVehicles from './use-user-vehicles'

const SERVICE_ID = '[VEHICLES CONNECTING TO WALLBOX]'

interface VehicleConnectingToWallboxDto {
  inProgress: boolean
  wallboxIds: [string]
}

interface VehicleConnectingToWallboxModel {
  inProgress: boolean
  wallboxIds: [string]
}

const transformDtoToModel = (dto: VehicleConnectingToWallboxDto): VehicleConnectingToWallboxModel => dto

/**
 * This hook provide information about the identification status of vehicles
 */
export const useVehiclesConnectingToWallboxSocket = (installationId: number | undefined): SocketStateModel<VehicleConnectingToWallboxModel> => {
  const vehiclesWebSocketApiPath = `vehicles/installations/${installationId}/vehicles/identification/ws`
  const { vehicles } = useUserVehicles(installationId)
  const userHasVehicle = vehicles && vehicles.length > 0

  const { socketState } = useWebSocketApi<VehicleConnectingToWallboxModel, VehicleConnectingToWallboxDto>({
    apiResourcePath: vehiclesWebSocketApiPath,
    loggerKey: SERVICE_ID,
    transformer: transformDtoToModel,
    dependencies: [installationId],
    doNotInitialize: isUndefined(installationId) || !userHasVehicle,
    endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT ?? '',
  })

  return socketState
}
